import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PermissionService } from 'src/app/services/api/permission.service';
import { BreadcrumbItem } from '../../models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import * as permissionsData from 'src/app/models/permissions.json';
import cloneDeep from 'lodash/cloneDeep';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.ROLE_READ,
    action: Permissions.ROLE_READ,
  },
  {
    key: PermissionKeys.ROLE_ASSIGN_READ,
    action: Permissions.ROLE_ASSIGN_READ,
  }
];

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    standalone: false
})
export class RolesComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  RouterSegments = RouterSegments;
  breadcrumbItems: BreadcrumbItem[];
  isLoading = true;
  data = [];
  roles = true;
  permissions = false;
  selectedRole: any;
  permissionsData: any;
  selectedPermission: any;
  initialPermissionData: any;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean; };

  constructor(private permissionsService: PermissionService, private toastrService: CustomToastrService,
    private authService: AuthService, private router: Router, private sidenavService: SidenavService, private permissionService: PermissionsService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.ROLE_READ]) {
      this.router.navigate(['/', this.authService.principal.provider, 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.ROLES';
    const permissions = permissionsData;
    this.initialPermissionData = permissions.permissionsData;
    this.permissionsData = cloneDeep(this.initialPermissionData)
    this.selectedPermission = this.permissionsData.find(item => item?.isSelected === true);

    this.breadcrumbItems = [];
    this.breadcrumbItems.push({icon: 'home'}, {label: translate('LEFT_SIDE_NAV.ACCESS_MANAGEMENT')}, 
      {label: translate('LEFT_SIDE_NAV.ROLES'), url: ['roles']});
    this.getRoles();
  }
 
  getRoles(): void {
    this.permissionsService.getRoles() .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(roles => {
      this.data = roles;
      this.isLoading = false;
    }, 
    (error) => {
      this.isLoading = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  goToPermissions(selectedRole): void {
    this.selectedRole = selectedRole;
    this.permissionsData = cloneDeep(this.initialPermissionData)
    this.selectedPermission = this.permissionsData.find(item => item?.isSelected === true);
    this.selectedRole?.permissions?.forEach(permission =>  {
      const actions = [permission.action];
      if (permission.action.startsWith('/')) {
        actions.push(permission.action.substring(1));
      } else {
        actions.push('/' + permission.action);
      }
      actions.forEach(action => {
      let tab = action.split('/')[1];
      if(action.includes("jumpbox")){
        tab = action.split('/')[2];
      } else if(action.includes("pe-connections")) {
        tab = action.split('/')[2];
      } else if(action.includes("runbook")) {
        tab = action.split('/')[2];
      } else if(action.includes("schedules")) {
        tab = action.split('/')[2];
      } else if(action.includes("jobs")) {
        tab = action.split('/')[2];
      }
      let row;
      if (action.split('/').length === 3 || tab === 'authz') {
        row = action.split('/')[2];
      } else {
        row = action.split('/')[2] + '/' + action.split('/')[3];
      }
      if (this.permissionsData.find(item => item.key === tab) && this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row) && 
        !this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions) {
        this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row).access = true;
      }
      if (this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions) {
        if (permission.attribute === 'datazone') { 
          const permissionItem = this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions
          .find(item => item.key === permission.attributeValue);
            if (permissionItem && permissionItem.access !== undefined) {
            permissionItem.access = true;
            }     

        } else if (permission.attribute === 'type') {
          this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row)
            .dataZonePermissions.map(item => item.infoDetails = [...item.infoDetails, permission.attributeValue]);
        } else {
          if (tab === 'authz') {
            const permissionItem = this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions
            .find(item => item.key === permission.action.split('/')[3]);
            if (permissionItem && permissionItem.access !== undefined) {
              permissionItem.access = true;
            }  
          }
        }
      }
    });
  })
    this.roles = false;
    this.permissions = true;
  }

  dataZonePermissions(permissions): boolean {
    return permissions.some(item => item.dataZonePermissions);
  }

  goToRoles(): void {
    this.roles = true;
    this.permissions = false;
  }

  selectPermission(permission): void {
    this.selectedPermission = permission;
    this.permissionsData.map(item => item.isSelected = false);
    this.permissionsData.find(item => item.key === permission.key).isSelected = true;
  }
}
